import { Subscription } from "rxjs";
import { DataTableFilterMessageService } from "../data-table-filter-message-service";

export abstract class BaseDataTableFilter {

    public id!: string;
    applyEventSubscription: Subscription;
    clearEventSubscription: Subscription;

    constructor(messageService: DataTableFilterMessageService) {
        this.applyEventSubscription = messageService.applyEvent.subscribe((filterId: string) => {
            if(this.id === filterId) {
                this.onApplyClicked();
            }
        });

        this.clearEventSubscription = messageService.clearEvent.subscribe((filterId: string) => {
            if(this.id === filterId) {
                this.onClearClicked();
            }
        });
    }

    clearSubscriptions(): void {
        if(this.applyEventSubscription) {
            this.applyEventSubscription.unsubscribe();
        }

        if(this.clearEventSubscription) {
            this.clearEventSubscription.unsubscribe();
        }
    }
    
    abstract onApplyClicked(): void;
    abstract onClearClicked(): void;
}